import React from 'react'

const Home = () => {
  return (
    <div>
      <div className=" flex h-screen w-full bg-blue-300"></div>
    </div>
  )
}

export default Home
